import { ComponentProps } from 'react';

import { cva, MergeVariantProps, VariantProps } from '../cva';

const variants = cva({
    base: 'material-symbols-rounded flex-none',
    variants: {
        variant: {
            outline: '[--font-FILL:0]',
            fill: '[--font-FILL:1]',
        },
    },
    defaultVariants: {
        variant: 'fill',
    },
});

export type IconProps = MergeVariantProps<
    Omit<ComponentProps<'span'>, 'children'> & {
        children: string;
    },
    VariantProps<typeof variants>
>;

export function Icon({ variant, ...props }: IconProps) {
    return <span {...props} className={variants({ ...props, variant })} />;
}
